var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMainBannerDottedLines = function SvgMainBannerDottedLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1211 613"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeOpacity: 0.1,
    strokeWidth: 3,
    d: "M-24.315 1.5c12.498 22.035-18.677 21.563 0 38.5 93.425 84.719 9.974 346.948 110 423.5 97.429 74.564 443.079-15.169 540.079 59.928 30.195 23.376 62.559 47.322 96.506 65.101 74.856 39.203 170.28 24.693 236.19-24.779 25.512-19.149 58.3-47.887 67.19-80.081 10.71-38.782-4.79-78.552-24.69-111.392-51.4-84.829-133.179-155.825-235.849-157.008-60.599-.699-93.719 51.965-79.707 108.914 9.804 39.845 48.577 62.217 82.638 79.856 48.62 25.177 108.289 36.477 162.797 31.536 87.411-7.922 148.531-63.355 212.181-118.938C1179.68 274 1231.18 192 1198.18 132.5"
  })));
};
export default SvgMainBannerDottedLines;